import axios from "axios";
import { getLocalStorage } from "./localStorage";
const cancelTokenSource = axios.CancelToken.source();

export const authApi = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT_URL,
  cancelToken: cancelTokenSource.token,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getLocalStorage("token")}`,
  },
});
export function updateAuthHeaders() {
  authApi.defaults.headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getLocalStorage("token")}`,
  };
}
